import { useState, useEffect } from 'react';
import { getAllZones } from '../services/configurationServices';

export const useZone = () => {
    const [zoneList, setZoneList] = useState([]);

    const getZoneList = () => {
        getAllZones()
            .then((res) => {
                console.log("Res", res)
                if (res.Status == "success") {
                    setZoneList(res.Data);
                }else{
                    setZoneList([])
                }
            }).catch((err) => {
                console.log(err);
            })
    }

    useEffect(() => {
        getZoneList()
    }, []);

    return { zoneList, setZoneList, getZoneList };
}

